import { useFeatureRole } from "@thooks/useFeatureRole"
import CollectionAdministrationHeader from "./components/CollectionAdministrationHeader/CollectionAdministrationHeader"
import CollectionAdministrationTabs from "./components/CollectionAdministrationTabs/CollectionAdministrationTabs"
import { COLLECTION_ADMINISTRATION_CODES, COLLECTION_ADMINISTRATION_CODES_NAMES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"
import { CustomSpin } from "@UI/CustomSpin"
import './styles.css'

const CollectionAdministrationPage = () => {

    const { loadingFeatures } = useFeatureRole({
        feature_codes: COLLECTION_ADMINISTRATION_CODES,
        validate_code: COLLECTION_ADMINISTRATION_CODES_NAMES.COLLECTION_ADMINISTRATION_MODULE,
        returnUrl: '/menu/settings',
    })

    if (loadingFeatures) return <CustomSpin tip="Cargando módulo" />
    return (
        <section className="section-wrapper">
            <CollectionAdministrationHeader />
            <CollectionAdministrationTabs />
        </section>
    )
}

export default CollectionAdministrationPage
